module.exports = __webpack_public_path__ + "img/icon-data.f4a1f995.png";